/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "DER_Split_Error",
        type: "error",
    },
    {
        inputs: [],
        name: "expmod_Error",
        type: "error",
    },
    {
        inputs: [],
        name: "k256Decompress_Invalid_Length_Error",
        type: "error",
    },
    {
        inputs: [],
        name: "k256DeriveY_Invalid_Prefix_Error",
        type: "error",
    },
    {
        inputs: [],
        name: "recoverV_Error",
        type: "error",
    },
];
const _bytecode = "0x60808060405234601757603a9081601d823930815050f35b600080fdfe600080fdfea26469706673582212204a0608d7bdc5040ddffbd702a496a3bf8f5e654fc0085ddabbb9b57c3936f2fb64736f6c63430008100033";
const isSuperArgs = (xs) => xs.length > 1;
export class EthereumUtils__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
EthereumUtils__factory.bytecode = _bytecode;
EthereumUtils__factory.abi = _abi;
//# sourceMappingURL=EthereumUtils__factory.js.map